import { IBuyMoreCartItem, ICartItem, IOrderInfo, IRecommendedItem } from '@/interfaces/cart'
import { IVariant } from '@/interfaces/product'
import { Route } from 'vue-router/types/router'

export interface IState {
  isInitialized: boolean;
  token: string | null,
  expireTime: string | null,
  isAuthenticated: boolean,
  coinLeft: number,
  coinValue: number,
  nuCoin: number,
  nuCoinExpireTime: string | null,
  nickname: string | null,
  account: string | null,
  country: string | null,
  email: string | null,
  id: string | null,
  isWebViewMode: boolean,
  routes: { from: Route | null, to: Route | null};
  showFooter: boolean;
  webAppCaps: { [key: string]: string | number } | undefined;
  cart: CartState,
  bypassConv: boolean,
  showNuCoin: boolean,
  showAddValue: boolean
}

export interface CartState {
  cartList: ICartItem[] | undefined;
  cartAmount: number;
  cartCheckedCount: number;
  buyMoreListCart: IBuyMoreCartItem[];
  buyMoreListOrder: IVariant[];
  orderInfo: IOrderInfo | null;
  noDeliverFeePrice: number;
  recList: IRecommendedItem[] | undefined;
}

export enum CartType {
  cart = 0,
  checkout = 1,
  count = 2
}
